import { forwardRef } from 'react'
import UpperContent from './UpperContent'
import PdfReportContent from './PdfReportContent'
import { getTgblFieldsDatePicker } from '../utils'
import GetContext from '../context/GetContext'

export const ExportPdf = forwardRef(({
  ...props
},ref) => {

  const { groupReportSnapshot, datePicker } = GetContext( props.context )

  const exportDateText = ['Course Report', 'User Report'].includes( props.from ) ? getTgblFieldsDatePicker( datePicker ).toUpperCase() : ''
  const header = (
    <div className='msync-exported-pdf-header' key={props.from}>
      <div className='msync-exported-pdf-header__container'>
        <span className='msync-exported-pdf-header__container__type'>{ props.from ?? '' }</span>
        <span className='msync-exported-pdf-header__container__date'>{ exportDateText }</span>
      </div>
      <div className='msync-exported-pdf-header__container'>
        <img src={groupReportSnapshot.logo} alt="logo" className='msync-exported-pdf-header__container__logo' />
      </div>
    </div>
  )

  return (
    <>
      <div ref={ref} className='msync-exported-pdf' key={ref}>
        {  header }
        <UpperContent from={props.from} context={props.context} />
        <PdfReportContent {...props} />
      </div>
    </>
  )
})
